/**
 * @desc: Copied from https://git.perkbox.io/backend-services/login/blob/master/internal/errorLib/codes.go
 */
var LoginCodes;
(function (LoginCodes) {
    LoginCodes["RequestUrlParamMissing"] = "PBLOGRequestUrlParamMissing";
    LoginCodes["RequestBodyInvalid"] = "PBLOGRequestBodyInvalid";
    LoginCodes["PreconditionFailedErr"] = "PBLOGPreconditionFailed";
    LoginCodes["PasswordMissing"] = "PBLOGPasswordMissing";
    LoginCodes["UserDisabled"] = "PBLOGUserDisabled";
    LoginCodes["UnexpectedLoginChallenge"] = "PBLOGUnexpectedLoginChallenge";
    LoginCodes["LoginChallengeNewPasswordRequired"] = "PBLOGLoginChallengeNewPasswordRequired";
    LoginCodes["InvalidLoginDetails"] = "PBLOGInvalidLoginDetails";
    LoginCodes["RespondToChallengeUnknown"] = "PBLOGRespondToChallengeUnknown";
    LoginCodes["RespondToChallengeInvalid"] = "PBLOGRespondToChallengeInvalid";
    LoginCodes["RespondToChallengeFailed"] = "PBLOGRespondToChallengeFailed";
    LoginCodes["UserNotFound"] = "PBLOGUserNotFound";
    LoginCodes["PasswordCriteriaFailed"] = "PBLOGPasswordCriteriaFailed";
    LoginCodes["PasswordTooWeak"] = "PBLOGPasswordTooWeak";
    LoginCodes["UserNotConfirmed"] = "PBLOGUserNotConfirmed";
    LoginCodes["LimitExceeded"] = "PBLOGLimitExceeded";
    LoginCodes["InvalidConfirmationCode"] = "PBLOGInvalidConfirmationCode";
    LoginCodes["ExpiredConfirmationCode"] = "PBLOGExpiredConfirmationCode";
    LoginCodes["ForgotPasswordSamlUser"] = "PBLOGForgotPasswordSamlUser";
    LoginCodes["PBLOGGlobalTenantNotFound"] = "PBLOGGlobalTenantNotFound";
})(LoginCodes || (LoginCodes = {}));
export default LoginCodes;
